module.exports = __webpack_public_path__ + "img/nuevo_b.3c39fda0.png";